import BaseText from "../BaseText";
import SvgComponent from "../SVGShape";
import { NotificationObject } from "../../interfaces";
import mixin from "../../utils/helperFunction";

interface NotificationItemProps {
  notificationObject: NotificationObject;
  clickEvent: (clickType: "view" | "close", notificationId: string) => void;
}

export default function BaseNotificationItem({
  notificationObject,
  clickEvent,
}: NotificationItemProps) {
  return (
    <>
      <div>
        <div className="pl-4 pr-8 gap-y-4 my-5">
          <div className="flex flex-col gap-y-4">
            <div className="flex justify-between">
              <div className="flex items-center gap-x-3">
                <div
                  className={`w-3 h-3 ${
                    notificationObject.isRead ? "bg-gray-400" : "bg-[#043299]"
                  } rounded-full`}
                />
                <BaseText
                  size="small"
                  weight="bold"
                  color={notificationObject.isRead ? "gray" : "blue"}
                >
                  {notificationObject?.title}
                </BaseText>
              </div>
              <span
                className="cursor-pointer duration-200"
                onClick={() => clickEvent("close", notificationObject.id)}
              >
                <SvgComponent icon={"cancel-circle-background"} />
              </span>
            </div>
            <span
              className="text-justify"
            >
              <div
                className="text-xs"
                style={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  WebkitLineClamp: 3,
                  maxHeight: `${3 * 1.4}em`
                }}
              >
                {notificationObject?.content}
              </div>
            </span>

            <div className="flex justify-between">
              <BaseText size="xs-small">
                Click
                <span
                  onClick={() => clickEvent("view", notificationObject.id)}
                  className="text-[#043299] underline px-1 cursor-pointer"
                >
                  here
                </span>
                to view
              </BaseText>
              <BaseText size="xs-small">
                {mixin.extractDate(notificationObject.createdDate)}
              </BaseText>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
